import { css } from 'lit';
export const dinapsisLateralSliderButtonPanelStyles = css `
    div {
        width: 72px;
        height: 42px;
        display: flex;
        align-items: center;
        z-index:1;
        background-color: #fff;
        cursor: pointer;
    }
    span {
        align-items: center; 
        width: 28px;
        height: 42px;
        cursor: pointer
    }
    .arrow {
        display: flex;
        background-color: #002f6c;
        user-select: none;
    }
    .button-icon {
        height: 42px;
        width: 44px;
        display: flex;
        font-size: 24px;
        line-height: 1;
        justify-content: center;
        margin: 0 auto;
        user-select: none;
    }
    img{
        width: 24px;
        height: 24px;
    }
    .material-icons-arrows {
        font-family: 'Material Icons';
        color: white;
        width: 24px;
        height: 24px;
        display: flex;
        font-size: 24px;
        line-height: 1;
    }
    .material-icons-round {
        font-family: 'Material Icons Round';
        color: #777;
        width: 24px;
        height: 24px;
        display: flex;
        font-size: 24px;
        line-height: 1;
    }
`;
//# sourceMappingURL=dinapsis-lateral-slider-panel-button-style.js.map